import { ReactElement, useState } from "react";
import { useHistory } from "react-router-dom";
import { useForm } from "react-hook-form";
import { header } from "../../shared/logos";
import { useDependency } from "../../contexts/DependencyContext";
import { LoginService } from "../../services/LoginService";
import CustomInput from "./CustomInput";
import styles from "./LoginPage.module.scss";
import useGlobalPanels from "../../hooks/UseGlobalPanels";

interface FormData
{
    userName: string;
    password: string;
}

const LoginPage = (): ReactElement =>
{
    const loginService = useDependency(LoginService);
    const history = useHistory();
    const { register, handleSubmit } = useForm<FormData>();
    const [state, setState] = useState({ loading: false, error: null });

    useGlobalPanels(false);

    const onSubmit = handleSubmit(({ userName, password }) =>
    {
        setState({ loading: true, error: null });

        loginService
            .login(userName, password)
            .then(() => history.push("/"))
            .catch(x => setState({ loading: false, error: x.message }));
    });

    return (
        <main className={styles.loginOverlay}>
            <div className={styles.login}>
            <div className={styles.headerWrapper}>
                {header}
            </div>

            <div className={styles.formWrapper}>
                <form onSubmit={onSubmit}>
                    <CustomInput
                        ref={register({ required: true })}
                        type="text"
                        name="userName"
                        label="Username"
                        autoComplete="login-username"
                        customClassName={styles.formGroup}
                    />

                    <CustomInput
                        ref={register({ required: true })}
                        type="password"
                        name="password"
                        label="Password"
                        autoComplete="login-password"
                        customClassName={styles.formGroup}
                    />


                    {!state.error || (
                        <span className={styles.validationError}>{state.error}</span>
                    )}

                    <button type="submit" disabled={state.loading} className="btn btn-info-light">
                        <span>Login</span>
                    </button>

                    <a className={styles.forgotPassword} href="www.google.com">
                        Forgot your password?
                    </a>
                </form>
            </div>
            </div>
        </main>
    );
};

export default LoginPage;
